import { atom } from 'recoil';

type DateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const kuchikomyuDateRangeState = atom<DateRange>({
  key: 'kuchikomyuDateRangeState',
  default: { startDate: null, endDate: null }
});